<div class="rs-maxh rs-padding-bottom2">
  <span id="ac-managePanel-anchor" aria-hidden="true" tabindex="-1"></span>
  <div class="rs-flex-grow rs-flex rs-flex-bottom" *ngIf="selectedViewType === ViewType.SIMPLE">
    <a
      href="javascript:void(0)"
      (click)="toggleCreateMode()"
      class="rs-btn jsrs-show-mail"
      data-tms-event="button-click"
      data-tms-button-zone="public wifi create account"
      attr.data-tms-button-name="{{ 'publicWifi.accountList.create.account' | translate }}"
      >{{ 'publicWifi.accountList.create.another.account' | translate }}</a
    >
  </div>
  <div
    class="panel rs-maxh rs-no-margin"
    id="ac-managePanel"
    role="region"
    aria-live="polite"
    *ngIf="selectedViewType !== ViewType.SIMPLE"
  >
    <div class="jsrs-default-view rs-maxh" *ngIf="selectedViewType === ViewType.DEFAULT">
      <div class="rs-maxh rs-flex rs-flex-dir-col">
        <px-alert
          [alertKey]="'publicWifiCreateAlert' + getValueWithoutDomain(account.technicalLoginId)"
        ></px-alert>
        <p
          class="rs-txt-s3"
          [innerHTML]="'publicWifi.accountList.manage.description' | translate: true"
        ></p>
        <div class="rs-flex-grow rs-flex rs-flex-bottom">
          <a
            href="javascript:void(0)"
            (click)="toggleCreateMode()"
            role="button"
            class="rs-btn jsrs-show-mail"
            data-tms-event="button-click"
            data-tms-button-zone="public wifi account"
            attr.data-tms-button-name="{{ 'publicWifi.accountList.create.account' | translate }}"
            >{{ 'publicWifi.accountList.create.account' | translate }}</a
          >
        </div>
      </div>
    </div>
    <div class="jsrs-edit-mail-view rs-maxh" *ngIf="selectedViewType === ViewType.CREATE">
      <px-alert
        [alertKey]="'publicWifiCreateAlert' + getValueWithoutDomain(account.technicalLoginId)"
      ></px-alert>
      <div class="rs-maxh rs-flex rs-flex-dir-col">
        <div
          class="rs-form-item"
          [ngClass]="!isLoginValid && (alias.touched || alias.dirty) && 'error'"
        >
          <div class="rs-flex-row">
            <div class="rs-flex-column">
              <input
                type="text"
                id="ac-login"
                name="alias"
                [(ngModel)]="login"
                (ngModelChange)="validateLogin()"
                #alias="ngModel"
                aria-describedby="ac-login-helper ac-login-success ac-login-error"
              />
              <label class="rs-form-label" for="ac-login">{{
                'publicWifi.accountList.manage.editMode.login' | translate
              }}</label>
            </div>
            <div class="rs-flex-column rs-flex-shrink">
              <div class="rs-padding-top2" id="ac-login-helper">
                {{ 'publicWifi.accountList.manage.editMode.domainName' | translate }}
              </div>
            </div>
          </div>
          <div class="rs-form-helper">
            <ul>
              <li *ngIf="isLoginValid" class="rs-form-success" id="ac-login-success">
                {{ 'publicWifi.accountList.manage.editMode.successMessageLogin' | translate }}
              </li>
              <li
                *ngIf="!isLoginValid && (alias.touched || alias.dirty)"
                class="rs-form-error"
                id="ac-login-error"
              >
                {{ 'publicWifi.accountList.manage.editMode.errorMessageLogin' | translate }}
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="columns small-12">
            <div class="rs-form-item">
              <input
                type="password"
                id="ac-pwd"
                name="password1"
                [(ngModel)]="password"
                #password1="ngModel"
                (ngModelChange)="validatePassword()"
                aria-describedby="ac-helper-pwd ac-success-pwd ac-error-pwd"
                class=""
              />
              <span
                class="jsrs-togglePassword rs-see-pwd"
                aria-label="See or hide password"
                role="button"
                tabindex="0"
              ></span>
              <label class="rs-form-label" for="ac-pwd">{{
                'publicWifi.accountList.manage.editMode.newPassword' | translate
              }}</label>
              <div class="rs-form-helper">
                <ul>
                  <li id="ac-helper-pwd">
                    {{ 'publicWifi.accountList.manage.editMode.passwordHelper' | translate }}
                  </li>
                  <li *ngIf="isPasswordValid" class="rs-form-success" id="ac-success-pwd">
                    {{
                      'publicWifi.accountList.manage.editMode.successMessagePassword' | translate
                    }}
                  </li>
                  <li
                    *ngIf="!isPasswordValid && (password1.touched || password1.dirty)"
                    class="rs-form-error"
                    id="ac-error-pwd"
                  >
                    {{ 'publicWifi.accountList.manage.editMode.errorMessagePassword' | translate }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="rs-form-item">
              <input
                type="password"
                id="ac-password3"
                name="password3"
                [(ngModel)]="confirmPassword"
                #password3="ngModel"
                (ngModelChange)="validateConfirmPassword()"
                aria-describedby="ac-error-password3"
              />
              <span
                class="jsrs-togglePassword rs-see-pwd"
                aria-label="See or hide password"
                role="button"
                tabindex="0"
              ></span>
              <label class="rs-form-label" for="ac-password3">{{
                'publicWifi.accountList.manage.editMode.confirmNewPassword' | translate
              }}</label>
              <div class="rs-form-helper">
                <ul>
                  <li
                    *ngIf="!isConfirmPasswordValid && (password3.touched || password3.dirty)"
                    class="rs-form-error"
                    id="ac-error-password3"
                  >
                    {{
                      'publicWifi.accountList.manage.editMode.errorMessagePasswordNotIdentical'
                        | translate
                    }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-flex-row rs-justify-right rs-flex-middle-medium rs-flex-dir-col-small-only">
          <div class="rs-flex-columns rs-order-m2">
            <div class="small-only-text-center">
              <button
                class="rs-btn"
                (click)="saveAccount()"
                data-tms-event="button-click"
                data-tms-button-zone="public wifi account"
                attr.data-tms-button-name="{{
                  'publicWifi.accountList.manage.editMode.save' | translate
                }}"
                [disabled]="
                  !isLoginValid || !isPasswordValid || !isConfirmPasswordValid || createAliasPending
                "
              >
                {{ 'publicWifi.accountList.manage.editMode.save' | translate
                }}<span class="show-for-sr">{{
                  'publicWifi.accountList.manage.editMode.save' | translate
                }}</span>
              </button>
            </div>
          </div>
          <div class="rs-flex-columns" *ngIf="createAliasPending">
            <px-loading-spinner></px-loading-spinner>
            <span class="show-for-sr">{{
              'publicWifi.accountList.manage.createAlias.spinner.accessibility' | translate
            }}</span>
          </div>
          <div class="rs-flex-columns rs-order-m1">
            <p class="small-only-text-center">
              <button
                class="rs-btn-no-style rs-link rs-txt-hover jsrs-show-default"
                aria-controls="ac-managePanel"
                data-tms-event="button-click"
                data-tms-button-zone="public wifi account"
                attr.data-tms-button-name="{{
                  'publicWifi.accountList.manage.editMode.cancel' | translate
                }}"
                (click)="cancel()"
                [disabled]="createAliasPending"
              >
                {{ 'publicWifi.accountList.manage.editMode.cancel' | translate }}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
